export const getters = {
 
    totalCasos: (state) => {
        return state.st_casos.length
    },
    posClick: (state, valor) => {

        // console.log("[getters]-posClic, state ",state);
        // console.log("[getters]-posClic, state.getters ",state.getters);
        // console.log("[getters]-posClic, state.getters ",state.getters.posClick);
        console.log("[getters]-posClic, payload ",valor);

        var ldiv = (valor) / 2;
        var ldiv2= Math.trunc(ldiv);
        console.log(ldiv,ldiv2);
        let resultado = "impar";
        if (ldiv === ldiv2){
            resultado = "par"
        }
        console.log("[getters]-posClic, resultado ",resultado);
        return resultado;
    },
}


// WEBPACK FOOTER //
// ./src/store/getters.js